import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

const app = createApp(App);

// アプリ起動時に認証状態をチェック
store.dispatch('checkAuth').then(() => {
  app.use(store);
  app.use(router);

  router.beforeEach((to, from, next) => {
    const isAuthenticated = store.getters.isAuthenticated; // Vuexから認証状態を取得

    // 認証されていない場合でもログインページまたはサインアップページへはアクセスを許可
    if (!isAuthenticated && (to.name === 'UserLogin' || to.name === 'UserSignup')) {
      next(); // そのまま進む
    } else if (!isAuthenticated) {
      next({ name: 'UserLogin' }); // 認証されていない場合はログイン画面へリダイレクト
    } else {
      next(); // 認証されている場合はそのまま進む
    }
  });

  app.mount('#app');
});